import React from 'react';
import { View, TouchableOpacity } from 'react-native';

import { TextPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import { Icon, Toggle, VFText } from '@vfgroup-oneplatform/foundation/Components';
import {
  withTheme,
  getThemeImages,
  LightThemeColors,
} from '@vfgroup-oneplatform/foundation/Components/Themes';

import FrameworkTestKeys from '../../../FrameworkTestKeys';

import styles from './permissionsItem.styles';

const PermissionsItem = props => {
  const {
    icon,
    iconSize,
    iconAccessibilityLabel,
    rightIconSize,
    rightIcon,
    rightIconAccessibilityLabel,
    onRightIconPress,
    title,
    titleAccessibilityLabel,
    description,
    descriptionAccessibilityLabel,
    initialValue,
    onAcceptanceChange,
    toggleValue,
    toggleAccessibilityLabel,
    titleStyle,
    descriptionStyle,
    containerStyle,
    renderControl,
    renderDescription,
    images,
    theme,
  } = props;
  const Images = { ...getThemeImages(theme.name), ...images };

  return (
    <>
      <View
        style={[styles.containerStyle, containerStyle]}
        testID={FrameworkTestKeys.settingsPermissionItemContainer}
      >
        <View
          style={styles.leftItemsContainer}
          testID={FrameworkTestKeys.settingsPermissionItemContainerView}
        >
          <Icon
            type="image"
            name={Images[icon]}
            size={iconSize}
            accessibilityLabel={iconAccessibilityLabel}
            testID={iconAccessibilityLabel}
            style={styles.leftIcon}
          />
          <VFText
            i18nKey={title}
            style={[styles.titleStyle(theme), titleStyle]}
            testKey={titleAccessibilityLabel}
          />
          {rightIcon && (
            <TouchableOpacity
              onPress={onRightIconPress}
              testID={FrameworkTestKeys.settingsPermissionItemTO}
            >
              <Icon
                type="image"
                name={Images[rightIcon]}
                size={rightIconSize}
                style={styles.rightIcon}
                accessibilityLabel={rightIconAccessibilityLabel}
                testID={rightIconAccessibilityLabel}
              />
            </TouchableOpacity>
          )}
        </View>

        {renderControl || (
          <Toggle
            initialValue={initialValue}
            selected={toggleValue}
            onChange={onAcceptanceChange}
            accessibilityLabel={toggleAccessibilityLabel}
            testID={toggleAccessibilityLabel}
          />
        )}
      </View>

      {renderDescription ? (
        <View
          style={[styles.descriptionStyle(theme), descriptionStyle]}
          testID={FrameworkTestKeys.settingsPermissionItemDescription}
        >
          {renderDescription}
        </View>
      ) : (
        <VFText
          i18nKey={description}
          style={[styles.descriptionStyle(theme), descriptionStyle]}
          testKey={descriptionAccessibilityLabel}
        />
      )}
    </>
  );
};

PermissionsItem.defaultProps = {
  theme: LightThemeColors,
  images: {},
};

PermissionsItem.propTypes = {
  icon: PropTypes.string,
  iconSize: PropTypes.number,
  iconAccessibilityLabel: PropTypes.string,
  rightIconSize: PropTypes.number,
  rightIcon: PropTypes.string,
  rightIconAccessibilityLabel: PropTypes.string,
  title: PropTypes.string,
  titleAccessibilityLabel: PropTypes.string,
  description: PropTypes.string,
  descriptionAccessibilityLabel: PropTypes.string,
  initialValue: PropTypes.bool,
  theme: PropTypes.object,
  renderDescription: PropTypes.element,
  renderControl: PropTypes.element,
  containerStyle: PropTypes.object,
  descriptionStyle: TextPropTypes.style,
  titleStyle: PropTypes.object,
  textContainerStyle: PropTypes.object,
  toggleAccessibilityLabel: PropTypes.string,
  toggleValue: PropTypes.bool,
  onAcceptanceChange: PropTypes.func,
  onRightIconPress: PropTypes.func,
  images: PropTypes.object,
};

export default withTheme(PermissionsItem);
